'use strict';

module.exports = function firstWhere(key, operator, value) {
  return this.where(key, operator, value).first() || null;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/collect.js/dist/methods/firstWhere.js
// module id = IGjD
// module chunks = 0